import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import { getUserRole } from 'utils/userRole';

interface Prop {
  privilege: number;
}

function LabelAdmin({ privilege }: Prop) {
  if (getUserRole(privilege)) {
    return (
      // @ts-expect-error
      <Button p="0px" margin="0 2px" round>
        <Text size="10px" color={color.suvaGrey} padding="2px">
          {getUserRole(privilege)}
        </Text>
      </Button>
    );
  }

  return null;
}

export default LabelAdmin;
